(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tukme-book-page"] && !Shopify.designMode) return;
  try {
    
(function () {
  function money(c){ return Math.round(c/100).toLocaleString('en-US') + ' ฿'; }
  function ymd(d){ return d.toISOString().slice(0,10); }
  var MONTHS=['January','February','March','April','May','June','July','August','September','October','November','December'];
  function to12h(t){ var p=t.split(':'); var h=+p[0]; return (h%12||12)+':'+p[1]+' '+(h<12?'AM':'PM'); }
  function expLabel(v){ return (((v&&v.title)||'').replace(/^tuk[-\s]?tuk[\s-]*/i,'').toLowerCase().replace(/^./,function(c){return c.toUpperCase();})); }
  function cleanName(n){ return (n||'').replace(/^\d+\s*\|\s*/,'').toLowerCase().replace(/\b[a-z]/g,function(c){return c.toUpperCase();}); }
  function startOfMonth(d){ return new Date(Date.UTC(d.getUTCFullYear(), d.getUTCMonth(), 1)); }
  function todayUTC(){ var n=new Date(); return new Date(Date.UTC(n.getFullYear(), n.getMonth(), n.getDate())); }

  function initWidget(root){
    if (root.dataset.tmInit) return; root.dataset.tmInit='1';
    var cfg; try { cfg = JSON.parse(root.querySelector('.tm-config').textContent); } catch(e){ return; }
    var $ = function(s){ return root.querySelector('[data-tm="'+s+'"]'); };
    var body = root.querySelector('.tm-book__body');
    var loading = $('loading');
    function fatal(detail){ if(loading) loading.hidden=true; var f=$('fatal'); if(f) f.hidden=false; if(detail) console.error('tukme booking:', detail); }
    var minG = cfg.minGuests||2, maxG = cfg.maxGuests||6;
    var tours = cfg.tours||[];
    var A = { tour:null, variants:[], durationMin:0, availability:{}, from:null, to:null };
    var state = { month:startOfMonth(new Date()), date:null, time:null, guests:minG, variantId:null };

    if(!tours.length){ fatal('no tours'); return; }

    // tour selector
    var tsel=$('tour-sel');
    tsel.innerHTML = tours.map(function(t){ return '<option value="'+t.handle+'">'+cleanName(t.name)+'</option>'; }).join('');
    tsel.addEventListener('change', function(){ var t=tours.find(function(x){return x.handle===tsel.value;}); if(t) loadTour(t); });

    populatePickup();
    // guests + calendar nav (bound once)
    $('minus').addEventListener('click', function(){ if(state.guests>minG){ state.guests--; renderOpts(); renderSummary(); } });
    $('plus').addEventListener('click', function(){ if(state.guests<maxG){ state.guests++; renderOpts(); renderSummary(); } });
    $('prev').addEventListener('click', function(){ state.month=new Date(Date.UTC(state.month.getUTCFullYear(), state.month.getUTCMonth()-1, 1)); renderCal(); });
    $('next').addEventListener('click', function(){ state.month=new Date(Date.UTC(state.month.getUTCFullYear(), state.month.getUTCMonth()+1, 1)); renderCal(); });

    // start on the first tour
    loadTour(tours[0]);

    function defVar(vs){ var w=vs.find(function(v){ var t=((v.title)||'').toLowerCase(); return t.indexOf('with')>=0 && t.indexOf('without')<0; }); return (w||vs[vs.length-1]||vs[0]||{}).id; }

    function loadTour(t){
      A.tour=t; A.variants=(t.variants||[]).filter(function(v){ return v.available!==false; });
      state.variantId=defVar(A.variants); state.date=null; state.time=null; state.guests=minG;
      hide('times'); hide('config-row'); hide('pickup-row'); hide('summary'); clearMsg();
      $('fatal').hidden=true; body.hidden=true; loading.hidden=false;
      A.from=todayUTC(); A.to=new Date(A.from); A.to.setUTCDate(A.to.getUTCDate()+(cfg.daysAhead||60));
      fetch(cfg.apiBase+'/availability?tour='+encodeURIComponent(t.handle)+'&from='+ymd(A.from)+'&to='+ymd(A.to))
        .then(function(r){ return r.ok?r.json():Promise.reject(r.status); })
        .then(function(j){ A.availability=j.availability||{}; A.durationMin=j.durationMin||0; loading.hidden=true; body.hidden=false; state.month=startOfMonth(new Date()); renderOpts(); renderCal(); })
        .catch(function(e){ fatal('availability '+e); });
    }
    function durationStr(){ if(!A.durationMin) return ''; var h=A.durationMin/60; return (h%1===0?h:(Math.round(h*10)/10))+' hours'; }

    function dateOpen(s){ var sl=A.availability[s]; return !!(sl && sl.some(function(x){ return x.available; })); }

    function renderCal(){
      $('month').textContent = MONTHS[state.month.getUTCMonth()] + ' ' + state.month.getUTCFullYear();
      var grid=$('grid'); grid.innerHTML='';
      var first=state.month, firstDow=first.getUTCDay();
      var dim=new Date(Date.UTC(first.getUTCFullYear(), first.getUTCMonth()+1, 0)).getUTCDate();
      var today=todayUTC();
      for(var i=0;i<firstDow;i++){ var e=document.createElement('div'); e.className='tm-day tm-day--empty'; grid.appendChild(e); }
      for(var day=1;day<=dim;day++){
        var d=new Date(Date.UTC(first.getUTCFullYear(), first.getUTCMonth(), day)); var s=ymd(d);
        var cell=document.createElement('button'); cell.type='button'; cell.textContent=day; cell.className='tm-day';
        if(d<today){ cell.className+=' tm-day--past'; cell.disabled=true; }
        else if(dateOpen(s)){ cell.className+=' tm-day--open'+(state.date===s?' tm-day--sel':''); (function(ss){ cell.addEventListener('click', function(){ selectDate(ss); }); })(s); }
        else { cell.className+=' tm-day--full'; cell.disabled=true; }
        grid.appendChild(cell);
      }
      $('prev').disabled = state.month <= startOfMonth(today);
    }
    function selectDate(s){
      state.date=s; state.time=null; renderCal();
      var pills=$('pills'); pills.innerHTML='';
      (A.availability[s]||[]).forEach(function(slot){
        var b=document.createElement('button'); b.type='button'; b.className='tm-pill';
        b.textContent=to12h(slot.time)+(slot.label?(' · '+slot.label):'');
        if(!slot.available) b.disabled=true; else b.addEventListener('click', function(){ selectTime(slot.time, b); });
        pills.appendChild(b);
      });
      $('times').hidden=false; hide('config-row'); hide('pickup-row'); hide('summary'); clearMsg();
    }
    function selectTime(t, btn){
      state.time=t;
      root.querySelectorAll('.tm-pill').forEach(function(p){ p.classList.remove('tm-pill--sel'); });
      btn.classList.add('tm-pill--sel');
      $('config-row').hidden=false; $('pickup-row').hidden=false; renderSummary();
    }
    function renderOpts(){
      var seg=$('opts-seg'); $('opts').hidden=A.variants.length<=1; seg.innerHTML='';
      A.variants.forEach(function(v){
        var b=document.createElement('button'); b.type='button'; b.className='tm-seg-btn'+(v.id===state.variantId?' tm-seg-btn--sel':'');
        b.textContent=expLabel(v)||v.title;
        b.addEventListener('click', function(){ state.variantId=v.id; renderOpts(); renderSummary(); });
        seg.appendChild(b);
      });
      $('guests').textContent=state.guests;
      $('guest-hint').textContent='Min '+minG+', max '+maxG+' · the whole tuk tuk is private to your group';
      $('minus').disabled=state.guests<=minG; $('plus').disabled=state.guests>=maxG;
    }
    function populatePickup(){
      var sel=$('pickup-sel'); if(!sel) return;
      var hotels=cfg.hotels||[];
      var html='<option value="" disabled selected>Select your hotel…</option>';
      hotels.forEach(function(h){ html+='<option value="'+h.replace(/"/g,'&quot;')+'">'+h+'</option>'; });
      html+='<option value="__other__">Other (tell us your hotel)</option>';
      sel.innerHTML=html;
      sel.addEventListener('change', function(){ var o=$('pickup-other'); o.hidden=sel.value!=='__other__'; if(sel.value==='__other__') o.focus(); });
    }
    function getPickup(){ var sel=$('pickup-sel'); if(!sel) return ''; if(sel.value==='__other__') return (($('pickup-other').value)||'').trim(); return sel.value||''; }
    function currentVariant(){ return A.variants.find(function(v){ return v.id===state.variantId; }) || A.variants[0]; }
    function renderSummary(){
      if(!state.time) return; var v=currentVariant(); if(!v) return;
      $('per-line').textContent=money(v.price)+' × '+state.guests+' guests';
      $('total').textContent=money(v.price*state.guests);
      $('summary').hidden=false;
    }

    $('reserve').addEventListener('click', function(){
      if(!state.date || !state.time || !A.tour) return;
      var pickup=getPickup();
      if(!pickup){ msg('Please choose your pickup / drop-off point.'); $('pickup-sel').focus(); return; }
      var btn=$('reserve'); btn.disabled=true; var orig=btn.textContent; btn.textContent='Reserving…'; clearMsg();
      var handle=A.tour.handle;
      fetch(cfg.apiBase+'/hold', { method:'POST', headers:{'Content-Type':'application/json'}, body:JSON.stringify({ tour:handle, date:state.date, time:state.time, guests:state.guests, pickup:pickup, experience:expLabel(currentVariant()) }) })
        .then(function(hr){ if(hr.status===409){ msg('That slot was just taken — please pick another time.'); loadTour(A.tour); btn.disabled=false; btn.textContent=orig; return null; } if(!hr.ok) throw new Error('hold_failed'); return hr.json(); })
        .then(function(hold){
          if(!hold) return; var v=currentVariant();
          return fetch('/cart/clear.js', { method:'POST', headers:{'Content-Type':'application/json'} })
            .then(function(){ return fetch('/cart/add.js', { method:'POST', headers:{'Content-Type':'application/json'}, body:JSON.stringify({ items:[{ id:v.id, quantity:state.guests, properties:{ 'Date':state.date, 'Departure':to12h(state.time), 'Duration':durationStr(), 'Guests':String(state.guests), 'Pickup':pickup, '_time':state.time, '_holdToken':hold.holdToken, '_tour':handle } }] }) }); })
            .then(function(addRes){ if(!addRes.ok) throw new Error('cart_failed'); window.location.href = cfg.checkoutUrl || '/checkout'; });
        })
        .catch(function(){ msg('Something went wrong. Please try again or contact us.'); btn.disabled=false; btn.textContent=orig; });
    });

    function hide(n){ var el=$(n); if(el) el.hidden=true; }
    function msg(t){ var m=$('msg'); m.textContent=t; m.classList.remove('tm-msg--ok'); m.hidden=false; }
    function clearMsg(){ var m=$('msg'); m.hidden=true; }
  }

  function boot(){ document.querySelectorAll('.tm-book--page').forEach(initWidget); }
  if (document.readyState !== 'loading') boot(); else document.addEventListener('DOMContentLoaded', boot);
})();

  } catch(e) { console.error(e); }
})();
})();
